import * as actionTypes from "../constants/actionTypes";
import * as reducerHelper from "../helpers/reducerHelper";

/**
 * Structure of object from quality control store:
 * - measurementResult {SpectralData | null}    - shows hidden records
 * - result {Object}                            - quality control result
 */

const initialState = {
    measurementResult: null,
    result: null
};

export const qualityControlReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.QUALITY_CONTROL_INIT:
            if (state[action.payload.tabId] !== undefined) {
                return reducerHelper.getNewState(
                    action.payload.tabId,
                    {
                        ...initialState
                    },
                    state
                );
            }

            let newInitialState = {};
            newInitialState[action.payload.tabId] = {...initialState};

            return {...state, ...newInitialState};
        case actionTypes.QC_SAVE_MEASURE_RESULT_AND_RUN_COLOR_DIFFERENCE:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    measurementResult: action.payload.result
                },
                state
            );
        case actionTypes.QC_SAVE_SPECTRAL_DIFFERENCE:
            if (state[action.payload.tabId] === undefined) {
                return state;
            }

            return reducerHelper.getNewState(
                action.payload.tabId,
                {
                    result: action.payload.result
                },
                state
            );
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let finalStateClose = {};

            for (let tab of action.payload.newTabList) {
                if (state[tab.id] !== undefined) {
                    finalStateClose[tab.id] = state[tab.id];
                }
            }

            return finalStateClose;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return {};
        default:
            return state;
    }
};
